module.exports = __webpack_public_path__ + "static/img/merchandise.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shopping/merchandise.jpg
// module id = KHot
// module chunks = 0